function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e), o; if (Object.getOwnPropertySymbols) { o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { var r, t; for (r = 1; r < arguments.length; r++) { t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive], i; if (void 0 !== e) { i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 4.5h12V6H1.5v12H12v1.5H0v-15zM22.5 6H12V4.5h12v15H12V18h10.5V6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68 8.25h1.77l2.65 7.5H9.4l-.49-1.54H6.15l-.51 1.54H4l2.68-7.5zm-.11 4.67h1.92l-.94-2.96-.98 2.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.818 11.767c.28-.547.432-1.146.432-1.767h1.5c0 .87-.215 1.702-.596 2.45a6.265 6.265 0 01-1.593 1.963 7.421 7.421 0 01-2.315 1.296l-.492-1.418a5.922 5.922 0 001.85-1.033 4.767 4.767 0 001.214-1.491z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.896 13.258a4.767 4.767 0 01-1.214-1.49l-1.336.681c.38.744.924 1.41 1.593 1.964a7.421 7.421 0 002.315 1.296l.492-1.417a5.922 5.922 0 01-1.85-1.034zM15.5 10V8.25H17V10h-1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 10.75h-7.5v-1.5H20v1.5z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2717_3241"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 4.5h12V6H1.5v12H12v1.5H0v-15zM22.5 6H12V4.5h12v15H12V18h10.5V6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68 8.25h1.77l2.65 7.5H9.4l-.49-1.54H6.15l-.51 1.54H4l2.68-7.5zm-.11 4.67h1.92l-.94-2.96-.98 2.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.818 11.767c.28-.547.432-1.146.432-1.767h1.5c0 .87-.215 1.702-.596 2.45a6.265 6.265 0 01-1.593 1.963 7.421 7.421 0 01-2.315 1.296l-.492-1.418a5.922 5.922 0 001.85-1.033 4.767 4.767 0 001.214-1.491z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.896 13.258a4.767 4.767 0 01-1.214-1.49l-1.336.681c.38.744.924 1.41 1.593 1.964a7.421 7.421 0 002.315 1.296l.492-1.417a5.922 5.922 0 01-1.85-1.034zM15.5 10V8.25H17V10h-1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 10.75h-7.5v-1.5H20v1.5z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2717_3241"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 9h24v3H3v24h21v3H0V9zm45 3H24V9h24v30H24v-3h21V12z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.36 16.5h3.54l5.3 15h-3.4l-.98-3.08H12.3l-1.02 3.08H8l5.36-15zm-.22 9.34h3.84l-1.88-5.92-1.96 5.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M33.636 23.534A7.744 7.744 0 0034.5 20h3a10.74 10.74 0 01-1.192 4.898c-.76 1.489-1.847 2.818-3.185 3.928a14.842 14.842 0 01-4.631 2.591l-.984-2.834a11.844 11.844 0 003.7-2.066c1.047-.87 1.867-1.884 2.428-2.983z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M33.792 26.517c-1.047-.87-1.867-1.884-2.429-2.983l-2.671 1.364c.76 1.489 1.848 2.818 3.185 3.928a14.842 14.842 0 004.631 2.591l.984-2.834a11.844 11.844 0 01-3.7-2.066zM31 20v-3.5h3V20h-3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M40 21.5H25v-3h15v3z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2717_3228"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h48v48H0z"
  }))))
};
export var Translation = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _objectSpread(_objectSpread({}, props), {}, {
    paths: compPaths,
    fill: "none"
  }));
});